
export function download(content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}

export function readJsonFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        // The result is the file's content as a string (from readAsText)
        const jsonString = event.target.result;
        // Parse the string into a JavaScript object
        const data = JSON.parse(jsonString);
        resolve(data);
      } catch (error) {
        reject(new Error('Failed to parse JSON file'));
      }
    };

    reader.onerror = (error) => {
      reject(error);
    };

    // Read the file content as text
    reader.readAsText(file);
  });
};